import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import styles from "./Connexion.module.css";
import {
  fetchConnexion,
  fetchConnexionAlias,
  connexionSelector,
  clearError,
} from "./connexionSlice";
import Button from "react-bootstrap/Button";
import Alert from "react-bootstrap/Alert";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { useHistory, useParams } from "react-router-dom";

export const Connexion = () => {
  // Onglet actif : 0 = connexion classique, 1 = connexion par alias
  const [activeTab, setActiveTab] = useState(0);

  // États pour le formulaire classique
  const [rest_value, setRestValue] = useState("");
  const [values, setValues] = useState({});

  // États pour le formulaire par alias
  const [aliasValues, setAliasValues] = useState({ alias: "", mdp: "" });

  // Nouvel état pour la méthode de connexion favorite ("classic", "alias" ou "")
  const [favoriteMethod, setFavoriteMethod] = useState("");

  const history = useHistory();
  const { loading, hasErrors, errorMessage } = useSelector(connexionSelector);
  const dispatch = useDispatch();
  let { rest_id } = useParams();

  // Au montage, lire la préférence favorite dans le localStorage et forcer l'onglet correspondant
  useEffect(() => {
    const fav = localStorage.getItem("favoriteConnection");
    if (fav === "classic" || fav === "alias") {
      setFavoriteMethod(fav);
      setActiveTab(fav === "classic" ? 0 : 1);
    }
  }, []);

  // Réinitialiser l'erreur au montage
  useEffect(() => {
    dispatch(clearError());
  }, [dispatch]);

  // Gestion de la visibilité du mot de passe (formulaire classique)
  const [showPassword, setShowPassword] = useState(false);
  const togglePasswordVisibility = () => setShowPassword(!showPassword);

  // Gestion de la visibilité du mot de passe (formulaire par alias)
  const [showPasswordAlias, setShowPasswordAlias] = useState(false);
  const togglePasswordVisibilityAlias = () => setShowPasswordAlias(!showPasswordAlias);

  // Correction de rest_id si besoin
  useEffect(() => {
    if (rest_id && rest_id !== "null" && rest_id !== "") {
      setRestValue(rest_id);
    } else {
      setRestValue("");
    }
  }, [rest_id]);

  // Changer d'onglet et vider l'erreur
  const handleSwitchTab = (tabIndex) => {
    setActiveTab(tabIndex);
    dispatch(clearError());
  };

  // Gestion du changement pour le formulaire classique
  const handleChange = (event) => {
    event.persist();
    setValues((prevValues) => ({
      ...prevValues,
      [event.target.name]: event.target.value,
    }));
  };

  // Gestion du changement pour le formulaire par alias
  const handleChangeAlias = (event) => {
    event.persist();
    setAliasValues((prevValues) => ({
      ...prevValues,
      [event.target.name]: event.target.value,
    }));
  };

  // Toggle pour la case à cocher de la méthode classique
  const toggleFavoriteClassic = () => {
    if (favoriteMethod === "classic") {
      setFavoriteMethod("");
      localStorage.removeItem("favoriteConnection");
    } else {
      setFavoriteMethod("classic");
      localStorage.setItem("favoriteConnection", "classic");
    }
  };

  // Toggle pour la case à cocher de la méthode par alias
  const toggleFavoriteAlias = () => {
    if (favoriteMethod === "alias") {
      setFavoriteMethod("");
      localStorage.removeItem("favoriteConnection");
    } else {
      setFavoriteMethod("alias");
      localStorage.setItem("favoriteConnection", "alias");
    }
  };

  // Soumission du formulaire classique
  const handleSubmit = (event) => {
    event.preventDefault();
    if (!rest_value.trim()) {
      alert("Veuillez renseigner un restaurant.");
    } else if (!values.id || !values.id.trim()) {
      alert("Veuillez renseigner un identifiant.");
    } else if (!values.mdp || !values.mdp.trim()) {
      alert("Veuillez renseigner un mot de passe.");
    } else {
      // Enregistrer la préférence favorite si la case est cochée
      if (favoriteMethod === "classic") {
        localStorage.setItem("favoriteConnection", "classic");
      }
      dispatch(fetchConnexion(rest_value, values.id, values.mdp));
    }
  };

  // Soumission du formulaire par alias
  const handleSubmitAlias = (event) => {
    event.preventDefault();
    if (!aliasValues.alias.trim()) {
      alert("Veuillez renseigner un alias.");
    } else if (!aliasValues.mdp.trim()) {
      alert("Veuillez renseigner un mot de passe.");
    } else {
      if (favoriteMethod === "alias") {
        localStorage.setItem("favoriteConnection", "alias");
      }
      dispatch(fetchConnexionAlias(aliasValues.alias, aliasValues.mdp));
    }
  };

  // Affichage de l'alerte d'erreur
  const errorFunction = () => {
    if (hasErrors && errorMessage) {
      const hasKeys =
        typeof errorMessage === "object" && Object.keys(errorMessage).length > 0;
      if (
        hasKeys ||
        (typeof errorMessage === "string" && errorMessage.trim() !== "")
      ) {
        const errorText =
          errorMessage.message?.message ||
          errorMessage.message ||
          errorMessage;
        return (
          <Alert variant="danger" className={styles.error_message}>
            {errorText}
          </Alert>
        );
      }
    }
    return null;
  };

  const OuvrirRapport = () => {};

  return (
    <div className={styles.div_form_connexion}>
      <img
        className={styles.logo_connexion}
        src={process.env.PUBLIC_URL + "/POKKYWEB_noir_L.png"}
        alt="Logo"
      />
      {errorFunction()}

      {/* Système d'onglets */}
      <div className={styles.tabContainer}>
        <button
          type="button"
          className={`${styles.tabButton} ${
            activeTab === 0 ? styles.activeTab : styles.inactiveTab
          }`}
          onClick={() => handleSwitchTab(0)}
        >
          Connexion classique
        </button>
        <button
          type="button"
          className={`${styles.tabButton} ${
            activeTab === 1 ? styles.activeTab : styles.inactiveTab
          }`}
          onClick={() => handleSwitchTab(1)}
        >
          Connexion par alias
        </button>
      </div>

      {/* Formulaire classique */}
      {activeTab === 0 && (
        <form onSubmit={handleSubmit}>
          <label htmlFor="rest">Restaurant</label>
          <input
            name="rest"
            onChange={(e) => setRestValue(e.target.value)}
            value={rest_value}
            required
            placeholder="Saisir le restaurant"
          />
          <label htmlFor="id">Identifiant</label>
          <input
            name="id"
            onChange={handleChange}
            value={values.id || ""}
            required
            placeholder="Saisir votre identifiant"
          />
          <label htmlFor="mdp">Mot de passe</label>
          <div className={styles.passwordContainer}>
            <input
              name="mdp"
              onChange={handleChange}
              type={showPassword ? "text" : "password"}
              value={values.mdp || ""}
              className={styles.passwordInput}
              required
              placeholder="Saisir votre mot de passe"
            />
            <FontAwesomeIcon
              icon={showPassword ? faEyeSlash : faEye}
              onClick={togglePasswordVisibility}
              className={styles.eyeIcon}
            />
          </div>
          {/* Case à cocher pour mémoriser la connexion classique */}
          <div className={styles.checkboxContainer}>
            <input
              type="checkbox"
              id="favoriteClassic"
              checked={favoriteMethod === "classic"}
              onChange={toggleFavoriteClassic}
            />
            <label htmlFor="favoriteClassic">
              Se souvenir de la méthode de connexion favorite
            </label>
          </div>
          <Button
            type="submit"
            variant="outline-danger"
            className={styles.button_connexion}
            onClick={OuvrirRapport}
          >
            Se connecter
          </Button>
        </form>
      )}

      {/* Formulaire par alias */}
      {activeTab === 1 && (
        <form onSubmit={handleSubmitAlias}>
          <label htmlFor="alias">Alias</label>
          <input
            name="alias"
            onChange={handleChangeAlias}
            value={aliasValues.alias || ""}
            required
            placeholder="Saisir votre alias"
          />
          <label htmlFor="mdp">Mot de passe</label>
          <div className={styles.passwordContainer}>
            <input
              name="mdp"
              onChange={handleChangeAlias}
              type={showPasswordAlias ? "text" : "password"}
              value={aliasValues.mdp || ""}
              className={styles.passwordInput}
              required
              placeholder="Saisir votre mot de passe"
            />
            <FontAwesomeIcon
              icon={showPasswordAlias ? faEyeSlash : faEye}
              onClick={togglePasswordVisibilityAlias}
              className={styles.eyeIcon}
            />
          </div>
          {/* Case à cocher pour mémoriser la connexion par alias */}
          <div className={styles.checkboxContainer}>
            <input
              type="checkbox"
              id="favoriteAlias"
              checked={favoriteMethod === "alias"}
              onChange={toggleFavoriteAlias}
            />
            <label htmlFor="favoriteAlias">
              Se souvenir de la méthode de connexion favorite
            </label>
          </div>
          <Button
            type="submit"
            variant="outline-danger"
            className={styles.button_connexion}
          >
            Se connecter
          </Button>
        </form>
      )}

      <footer className={styles.div_Copyright}>
        <p>Copyright Cocirel - Tous droits réservés</p>
      </footer>
    </div>
  );
};

export default Connexion;
